import { LayoutConfig } from '@spartacus/storefront'

export const ebHeaderLayoutConfig: LayoutConfig = {
  layoutSlots: {
    header: {
      lg: {
        slots: [
          'CountrySelection',
          'SiteLinks',
          'SiteLogo',
          'SearchBox',
          'SiteLogin',
          'Register',
          'MiniCart'
        ]
      },
      md: {
        slots: ['CountrySelection', 'SiteLogo', 'SearchBox', 'MiniCart', 'PreHeader']
      },
      sm: {
        slots: ['SiteLogo', 'SearchBox', 'MiniCart', 'PreHeader']
      },
      xs: {
        slots: ['SiteLogo', 'SearchBox', 'MiniCart', 'PreHeader']
      }
    },
    countrySelection: {
      slots: []
    },
    preHeader: {
      slots: []
    },
    bottomHeader: {
      lg: {
        slots: ['NavigationBar']
      },
      md: {
        slots: []
      },
      sm: {
        slots: []
      },
      xs: {
        slots: []
      }
    },
    navigation: {
      lg: {
        slots: []
      },
      md: {
        slots: ['SiteLogin', 'Register', 'NavigationBar', 'SiteLinks', 'CountrySelection']
      },
      sm: {
        slots: ['SiteLogin', 'Register', 'NavigationBar', 'SiteLinks', 'CountrySelection']
      },
      xs: {
        slots: ['SiteLogin', 'Register', 'NavigationBar', 'SiteLinks', 'CountrySelection']
      }
    }
  }
}
